import * as React from "react";
const SvgFiRrPeanut = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-peanut_svg__a)">
      <path
        fill="#062147"
        d="M21.997 2.003c-2.83-2.83-7.631-2.63-10.704.442a8.4 8.4 0 0 0-2.062 3.36A5.24 5.24 0 0 1 5.806 9.23a8.4 8.4 0 0 0-3.36 2.062c-3.072 3.073-3.27 7.875-.441 10.704 1.338 1.338 3.117 1.998 4.945 1.998 2.039 0 4.139-.821 5.759-2.44a8.4 8.4 0 0 0 2.062-3.36 5.24 5.24 0 0 1 3.425-3.425 8.4 8.4 0 0 0 3.359-2.062c3.073-3.073 3.27-7.875.442-10.704m-1.856 9.29a6.4 6.4 0 0 1-2.556 1.572 7.3 7.3 0 0 0-4.72 4.719 6.4 6.4 0 0 1-1.572 2.557c-2.293 2.292-5.826 2.492-7.875.442S1.567 15 3.86 12.707a6.4 6.4 0 0 1 2.556-1.572 7.3 7.3 0 0 0 4.719-4.72 6.4 6.4 0 0 1 1.573-2.556C13.938 2.629 15.527 2 17.052 2c1.315 0 2.583.467 3.532 1.416 2.049 2.05 1.85 5.583-.443 7.876M12 13.5A1.5 1.5 0 1 1 9 13.499a1.5 1.5 0 0 1 3 0m-3 4A1.5 1.5 0 1 1 6 17.499a1.5 1.5 0 0 1 3 0m9-12A1.5 1.5 0 1 1 15 5.499a1.5 1.5 0 0 1 3 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-peanut_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPeanut;
